const convertLocaleToCountry = (locale) => {
  if (locale === 'en') return 'US';
  else {
    const country = locale.slice(-2);
    return country.toUpperCase(); //default to US english
  }
};

module.exports = convertLocaleToCountry;
